module.exports = __webpack_public_path__ + "static/title-a588a6271af26c1cd9e0310e9e58e854.png";